// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"StandardSidebar_sidebar__F1knA"};